export const termsContent = {
  companyName: '주식회사 서울소프트',
  companyNameEn: 'Seoul-Soft Co., Ltd.',
  serviceName: 'EasyAutoCall',

  // 회사 정보
  companyInfo: {
    ceo: '노병진',
    businessNumber: '134-87-18556',
    headquarters: '충청북도 충주시 중앙로 80 (네오메디클리닉), 501호',
    researchLab: '서울특별시 금천구 가산디지털1로 84, 810호',
    tel: '02-6052-1192',
    fax: '02-600-9349',
    email: 'hshwang@seoul-soft.com'
  },

  terms: [
    { title: '제1조 (목적)', content: `본 약관은 주식회사 서울소프트(이하 "회사")가 제공하는 EasyAutoCall 서비스(이하 "서비스") 이용과 관련하여 회사와 이용자 간의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.` },
    { title: '제2조 (정의)', content: `1. "서비스"란 회사가 제공하는 TTS 기반 자동 전화 발신 및 설문조사 서비스입니다.\n2. "회원"이란 본 약관에 동의하고 이용계약을 체결한 자를 말합니다.\n3. "크레딧"이란 서비스 이용을 위해 회원이 선불로 충전하는 결제수단을 의미합니다.` },
    { title: '제3조 (약관의 효력 및 변경)', content: `1. 본 약관은 서비스 화면에 게시함으로써 효력이 발생합니다.\n2. 회사는 필요한 경우 관련 법령을 위배하지 않는 범위에서 본 약관을 변경할 수 있으며, 변경 시 7일 전 공지합니다.\n3. 이용자가 변경된 약관에 동의하지 않을 경우 회원탈퇴로 계약을 해지할 수 있습니다.` },
    { title: '제4조 (회원가입 및 이용계약)', content: `1. 이용계약은 회원이 회사가 정한 가입 양식에 따라 신청하고 회사가 이를 승낙함으로써 체결됩니다.\n2. 회사는 다음 각 호의 경우 승낙을 유보하거나 거부할 수 있습니다.\n   - 실명이 아니거나 타인의 명의를 이용한 경우\n   - 허위정보 기재 또는 필수정보 누락 시\n   - 기타 회사의 운영정책상 부적합한 경우` },
    { title: '제5조 (서비스의 제공 및 변경)', content: `1. 회사는 다음 서비스를 제공합니다.\n   - TTS 자동전화발신 / 설문조사 / 이력조회 / 크레딧관리\n2. 기술적·운영상 사유로 변경·중단될 수 있으며, 사전 공지합니다.` },
    { title: '제6조 (크레딧 및 요금)', content: `1. 기본 요금은 1회 발신당 30원이며, 회사는 사전공지 후 변경할 수 있습니다.\n2. 크레딧 유효기간은 충전일로부터 1년이며 만료 시 자동 소멸됩니다.\n3. 미사용 크레딧의 환불은 요청일로부터 7일 이내 처리하며, PG 수수료를 제외할 수 있습니다.` },
    { title: '제7조 (이용제한 및 계약해지)', content: `1. 회원이 약관을 위반하거나 불법 스팸 발송 등 관련 법령을 위반할 경우 회사는 서비스 이용을 제한하거나 해지할 수 있습니다.\n2. 회원은 언제든지 서비스 내 탈퇴 절차를 통해 계약을 해지할 수 있습니다.` },
    { title: '제8조 (저작권 및 콘텐츠 관리)', content: `1. 서비스 내 게시물의 저작권은 회원에게 있으나, 회사는 서비스 홍보를 위해 이를 무상 사용·게시할 수 있습니다.\n2. 저작권 침해 등 불법 게시물은 신고 시 즉시 삭제될 수 있습니다.` },
    { title: '제9조 (전자적 통지)', content: `회사는 회원에게 중요한 사항을 이메일(hshwang@seoul-soft.com) 또는 서비스 내 알림으로 통지할 수 있으며, 이는 서면 통지와 동일한 효력을 가집니다.` },
    { title: '제10조 (면책조항)', content: `1. 천재지변, 통신장애, 시스템 점검 등 불가항력 사유로 인한 서비스 중단에 대해 회사는 책임을 지지 않습니다.\n2. 회원의 귀책사유로 인한 이용 장애에 대해서도 책임을 지지 않습니다.` },
    { title: '제11조 (분쟁해결 및 관할)', content: `1. 본 약관에 정하지 아니한 사항은 관련 법령 및 공정거래위원회 고시에 따릅니다.\n2. 분쟁 발생 시 회사 본사 소재지 관할 법원을 전속 관할로 합니다.` }
  ]
};
